/**
 * Groundworx GTM Admin Settings
 */
import { createRoot } from '@wordpress/element';
import SettingsPage from './admin/SettingsPage';
import './admin/settings.scss';

document.addEventListener('DOMContentLoaded', () => {
	const container = document.getElementById('groundworx-gtm-settings');
	if (container) {
		const root = createRoot(container);
		root.render(<SettingsPage />);
	}
});
